module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/10mill-active-a2a1005ea84ccceb6ebb782c47b8b809.png";